import { SCREEN_NAME } from 'constants/index';
import {
  CommunityAnalyticsClient,
  eventType,
} from '@atlassian/community-library';

export const setUserInfo = (aaid: string) => {
  CommunityAnalyticsClient.setAnalyticsUserInfo(aaid);
};

type ScreenEventProps = {
  screenName: SCREEN_NAME;
  attributes?: { [key: string]: string | boolean | number };
  isPersonalView: boolean;
};

export const sendScreenEvent = ({
  screenName,
  attributes,
  isPersonalView,
}: ScreenEventProps) => {
  CommunityAnalyticsClient.sendEvent(eventType.SCREEN, {
    name: screenName,
    attributes: {
      isPersonalView,
      ...attributes,
    },
  });
};

type TrackEventProps = {
  source: SCREEN_NAME;
  action: string;
  actionSubject: string;
  actionSubjectId?: string;
  attributes?: { [key: string]: string | boolean | number };
  isPersonalView: boolean;
};

export const sendTrackEvent = ({
  source,
  action,
  actionSubject,
  actionSubjectId,
  attributes,
  isPersonalView,
}: TrackEventProps) => {
  CommunityAnalyticsClient.sendEvent(eventType.TRACK, {
    action,
    actionSubject,
    attributes: {
      isPersonalView,
      ...attributes,
    },
    source,
    actionSubjectId,
  });
};

type UIEventProps = {
  source: SCREEN_NAME;
  action: string;
  actionSubject: string;
  actionSubjectId?: string;
  attributes?: { [key: string]: string | boolean | number };
  isPersonalView: boolean;
};

export const sendUIEvent = ({
  source,
  action,
  actionSubject,
  actionSubjectId,
  attributes,
  isPersonalView,
}: UIEventProps) => {
  CommunityAnalyticsClient.sendEvent(eventType.UI, {
    action,
    actionSubject,
    attributes: {
      isPersonalView,
      ...attributes,
    },
    source,
    actionSubjectId,
  });
};
